module.exports = __webpack_public_path__ + "img/platform-features.3a62769c.jpg";